import React, { useRef, useEffect } from "react";

const OTPInput = ({ length, otpDigits, setOtpDigits }) => {
  const inputRefs = useRef(Array.from({ length }, () => React.createRef()));

  useEffect(() => {
    inputRefs.current[0].current.focus();
  }, []);

  const handleOTPInput = (event, inputIndex) => {
    // console.log("onChange Event");
    const input = event.target;
    const newOtpDigits = [...otpDigits];
    let enteredDigit = "";
    // console.log(event.key);
    if (event.key === undefined || event.key === "Unidentified") {
      // Fallback for keyboards where event.key is not available
      enteredDigit = input.value[input.value.length - 1];
      // console.log("enteredDigit", enteredDigit);
      if (enteredDigit === undefined) {
        if (newOtpDigits[inputIndex]) {
          newOtpDigits[inputIndex] = "";
          setOtpDigits(newOtpDigits);
          if (inputIndex > 0) {
            const previousInput = inputRefs.current[inputIndex - 1].current;
            previousInput.focus();
          }
        } else {
          if (inputIndex > 0) {
            const previousInput = inputRefs.current[inputIndex - 1].current;
            previousInput.focus();
            previousInput.value = "";
            newOtpDigits[inputIndex - 1] = "";
            setOtpDigits(newOtpDigits);
          }
        }
      }
    } else {
      enteredDigit = event.key;
    }
    if (
      !isNaN(enteredDigit) &&
      enteredDigit >= 0 &&
      enteredDigit <= 9 &&
      inputIndex < length
    ) {
      if (newOtpDigits[inputIndex] === "") {
        newOtpDigits[inputIndex] = enteredDigit;
        setOtpDigits(newOtpDigits);
        if (inputIndex < length - 1) {
          const nextInput = inputRefs.current[inputIndex + 1].current;
          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
    // Clear the input value to prevent displaying the entered digit
    input.value = "";
  };

  const handleOTPInput2 = (event, inputIndex) => {
    // console.log("onKeyDown Event");
    const input = event.target;
    const newOtpDigits = [...otpDigits];
    // console.log(event.key);
    if (event.key === "Backspace" || event.key === "Delete") {
      event.preventDefault();
      if (newOtpDigits[inputIndex]) {
        newOtpDigits[inputIndex] = "";
        setOtpDigits(newOtpDigits);
      }
      if (event.key === "Backspace" && inputIndex > 0) {
        if (inputIndex === 5) {
          const currentInput = inputRefs.current[inputIndex].current;
          if (currentInput.value) {
            currentInput.focus();
            currentInput.value = "";
            newOtpDigits[inputIndex] = "";
            setOtpDigits(newOtpDigits);
          } else {
            const previousInput = inputRefs.current[inputIndex - 1].current;
            previousInput.focus();
            previousInput.value = "";
            newOtpDigits[inputIndex - 1] = "";
            setOtpDigits(newOtpDigits);
          }
        } else {
          const previousInput = inputRefs.current[inputIndex - 1].current;
          previousInput.focus();
          previousInput.value = "";
          newOtpDigits[inputIndex - 1] = "";
          setOtpDigits(newOtpDigits);
        }
      }
    }
    input.value = "";
  };

  const handleInputClick = (event) => {
    const currentInputIndex = inputRefs.current.findIndex(
      (ref) => ref.current === event.target
    );
    const currentIndex = otpDigits.findIndex((digit) => digit === "");
    if (currentIndex == -1) {
      event.preventDefault();
      inputRefs.current[5].current.focus();
    }

    if (currentIndex > -1 && currentIndex !== currentInputIndex) {
      event.preventDefault();
      inputRefs.current[currentIndex].current.focus();
    }
  };

  return (
    <>
      <div
        style={{
          height: "33px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        {otpDigits.map((digit, index) => (
          <input
            key={index}
            inputMode="numeric"
            type="password"
            value={digit ? "•" : ""}
            maxLength={1}
            placeholder={"_"}
            id={`otp-input-${index}`}
            ref={inputRefs.current[index]}
            onChange={(event) => handleOTPInput(event, index)}
            onKeyDown={(event) => handleOTPInput2(event, index)}
            onClick={handleInputClick}
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "8px",
              backgroundColor: "#F1F1F1",
              border: "1px solid #A7A7A7",
              textAlign: "center",
            }}
          />
        ))}
      </div>
      {/* <p>print OTP: {otpDigits.join("")}</p> */}
    </>
  );
};

export default OTPInput;
